import { Resource } from '../../../http/resource/resource.model';

export class TBCPortal extends Resource {
  // id is inherited from Resource
  // client_id is inherited from Resource
  tbc: string;
  // tslint:disable-next-line: variable-name
  totvs_user: number;
  // tslint:disable-next-line: variable-name
  totvs_pass: number;
  // tslint:disable-next-line: variable-name
  use_methods_without_license: boolean;
  // tslint:disable-next-line: variable-name
  use_totvs_oracle: boolean;
  use_methods_rest: boolean;
}
